import IconGreenCheck from './IconGreenCheck';

export default IconGreenCheck;
